import { Container, Title, Banner } from '@tryhackme/thm-ui-components';
import { ReactComponent as UserOccupationIcon } from 'src/images/svgs/user-occupation.svg';
import { Users } from './components/user-occupation-tables';
export const AdminUserOccupation = () => <section data-sentry-component="AdminUserOccupation" data-sentry-source-file="index.tsx">
    <Banner Image={UserOccupationIcon} data-sentry-element="Banner" data-sentry-source-file="index.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <Title isInBanner titleText="User Occupation Details" subTitleText="Our most active users' occupation details" data-sentry-element="Title" data-sentry-source-file="index.tsx" />
      </Container>
    </Banner>
    <Users data-sentry-element="Users" data-sentry-source-file="index.tsx" />
  </section>;